import { LocationKey } from '../models/utils';

export interface LocaleSettings {
  timezone: string;
  dateFormat: string;
}

export interface Location {
  key: LocationKey;
  name: string;
  localeSettings: LocaleSettings;
}

export const nullLocation: Location = {
  key: 'null' as LocationKey,
  name: 'Loading ...',
  localeSettings: {
    dateFormat: 'YYYY-MM-DD',
    timezone: 'Etc/UTC',
  },
};

export const notFoundLocation: Location = {
  key: 'not found' as LocationKey,
  name: 'not found',
  localeSettings: {
    dateFormat: 'YYYY-MM-DD',
    timezone: 'Etc/UTC',
  },
};

export interface LocationsState {
  isFetching: boolean;
  error?: Object;
  all?: Location[];
  selectedLocationKey: string;
  current: Location;
}
